<template>
  <div>
    <PageHeader title="Organisations">
      <CreateButton @click="openModal = true">Nouvelle organisation</CreateButton>
    </PageHeader>

    <CreateOrganizationModal :open-modal="openModal" @close="openModal = false" />

    <OrganizationList />
  </div>
</template>

<script>
import { CreateButton, PageHeader } from "@estaly/ui";
import OrganizationList from "@/views/organizations/OrganizationList.vue";
import CreateOrganizationModal from "@/views/organizations/CreateOrganizationModal.vue";

export default {
  components: {
    PageHeader,
    OrganizationList,
    CreateOrganizationModal,
    CreateButton,
  },

  data() {
    return {
      openModal: false,
    };
  },
};
</script>
